import { ColumnsByBreakpoint } from '../../helpers/columns/types';

// This object's values should be matched by those of `categoryLinksWidthInColumns`
export const accordionWidthInColumns: ColumnsByBreakpoint = {
  desktop: 10,
  tabletLandscape: 10,
  tabletPortrait: 6,
  mobile: 4,
};
